import { render, staticRenderFns } from "./manageForm.vue?vue&type=template&id=5cec1294&scoped=true"
import script from "./manageForm.vue?vue&type=script&lang=js"
export * from "./manageForm.vue?vue&type=script&lang=js"
import style0 from "./manageForm.vue?vue&type=style&index=0&id=5cec1294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cec1294",
  null
  
)

export default component.exports